import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { OnboardingProps } from "../common";

export const SupportV2NewLookModal = memo(function SupportV2NewLookModal({
  handleDismiss,
  handleComplete,
}: OnboardingProps) {
  return (
    <RedoModal
      modalSize="sm"
      onModalCloseRequested={handleDismiss}
      primaryButton={{ text: "Got it", onClick: handleComplete, size: "sm" }}
      title="Support has a new look!"
    >
      <Flex dir="column" gap="lg">
        <Text fontSize="sm" textColor="secondary">
          Let us know if anything is missing or doesn&apos;t work as you would
          expect by clicking the feedback button in the top right!
        </Text>
      </Flex>
    </RedoModal>
  );
});
